/**
 * Bearer 토큰이 query/환경변수 등으로 넘어오며 `encodeURIComponent` 된 경우
 * (`%3D`, `%2B` 등) Authorization 헤더에는 디코드된 원문 JWT를 보내야 함.
 * 표준 JWT(퍼센트 없음)는 그대로 통과.
 */
export function normalizeBearerTokenForAuthorization(raw: string): string {
	let t = raw.trim();
	if (!t) return t;
	if (!t.includes('%')) return t;
	try {
		let prev = '';
		let cur = t;
		// 이중 인코딩(%253D 등)까지 완화
		for (let i = 0; i < 3 && cur !== prev && cur.includes('%'); i++) {
			prev = cur;
			cur = decodeURIComponent(cur);
		}
		return cur;
	} catch {
		return t;
	}
}
